module.exports = __webpack_public_path__ + "static/media/startRoutePin.63e96204.png";